import { IAppRoute } from 'interfaces/route';
import { userRoles } from 'interfaces/user';
import React from 'react';

import Manual from './Manual/List';

export default class HelpRouter extends React.PureComponent {
  public static routes: IAppRoute[] = [
    {
      path: '/files',
      sideDrawer: { display: 'Arquivos' },
      roles: [userRoles.admin, userRoles.sysAdmin, userRoles.auditor, userRoles.holding, userRoles.venturer, userRoles.operator],
      component: Manual
    },
    {
      path: '/support',
      exact: true,
      sideDrawer: { display: 'Suporte' },
      roles: Object.keys(userRoles),
      component: () => null
    }
  ];

  render() {
    return (this.props.children);
  }
}
